import { render, staticRenderFns } from "./SoftwareDev.vue?vue&type=template&id=6436bb82"
import script from "./SoftwareDev.vue?vue&type=script&lang=js"
export * from "./SoftwareDev.vue?vue&type=script&lang=js"
import style0 from "./SoftwareDev.vue?vue&type=style&index=0&id=6436bb82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports